import React, { useState, useEffect, useContext  } from "react";
import {
  Typography
} from "@mui/material";

import {
  useQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useParams } from 'react-router-dom';
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";
import * as api from '../../../actions/api';
import PatientFormData from './PatientFormData.js'; 
import {
  DeleteOutline,
  Edit
} from "@mui/icons-material";
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import { UserContext } from "../../../context/user-info-context";


import { format } from 'date-fns';
import encryptionService from "../../../services/encryptionService";
//get DispensingLanguage

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const AddPatient = (props) => {

  const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
  const lan = localStorage.getItem('LangCode');
  const menukey = "patients";
  const LABTest_List =JSON.parse(localStorage.getItem("LABTest_List"));
  const FacilityId=localStorage.getItem('FacilityId');
  const UserInfo = encryptionService.decryptUserInfo();  
  const UserName = UserInfo==0?'': UserInfo[0].name;

  const userCtx = useContext(UserContext);
 
  // const lan = userCtx.userInfo.LangId; //"fr_FR";


  const { t, i18n } = useTranslation();

  const [generatedInvoiceNo, setGeneratedInvoiceNo] = useState(
    ''
  ); 



  const [formData, setFormData] = useState({
    lastName: "",
    idNumber: "",
    registered: "",//new Date(),
    firstName: "",
    pass: generatedInvoiceNo,
    deceased: null,
    knownName: "",
    ipn: "",
    transfferedIn: null,
    gender: "",
    OriginTypeId: 1,
    dob: null,
    transferredOut: null,
    maritalStatus: "",
    active: "",
    PreEP: "",
    isArmy: "",
    InhIsPrevious: "",
    defaulter: null,
    languagePreference: "",
    ProtocolId: "",
    MmdId: "",
    ExistingProtocolId: "",
    ExistingMmdId: "",
    temporaryPatient: "",
    stopped: null,
    InhStartDate: null,
    InhEndDate: null,
    address: "",
    contactNumber: "",
    email: "",
    allergiesData: [],
    anthropometricsData: [],
    labResultsData: [],
    firstProtocolName: "",
    TransferFromFacilityId: "",
    TransferToFacilityId: "",
    TransferFromCountryId: "",
    TransferToCountryId: "",
    PatientcoinfectionId: "",
    KeypopulationTypeId: "",
    CohortId: ""
  });

  let params={"menukey": "patient", "FacilityId":FacilityId, "TransactionTypeId":'', "Page":'Patient', TransactionDate: ''};
  const { data:invoiceNo } = useQuery([params], api.getInvoiceNo, 
    {onSuccess: (data) => { 
      setGeneratedInvoiceNo(data);
      let fdata = { ...formData }; 
      fdata["pass"] = data; 
      setFormData(fdata); 

    }}
    );


  const [allergyData, setAllergyData] = useState({
    id: null,
    date: null,
    allergyTitle: null,
    description: null,
    source: null
  });

  const [anthropometricData, setAnthropometricData] = useState({
    id: null,
    date: null,
    weight: null,
    height: null,
    bmi: null,
    bsa: null
  });


  const [labResultData, setLabResultData] = useState({
    id: null,
    testCode: null,
    testName: null,
    testResult: null,
    testDate: null,
    LocationId: null
  });

  const [openAllergyDialog, setAllergyDialog] = useState(false);
  const [openAnthropometricDialog, setAnthropometricDialog] = useState(false);
  const [openLabResultDialog, setLabResultDialog] = useState(false);
  // const [patientsPrescriptions, setPatientsPrescriptions] = useState([]);

  const [errorObject, setErrorObject] = useState({});
  const [errorAllergiesData, setErrorAllergiesObject] = useState({});
  const [errorAnthropometricsData, setErrorAnthropometricsObject] = useState({});
  const [errorLabResultsData, setErrorLabResultsObject] = useState({});

  const [tabValue, setTabValue] = useState(0);
  const [pricebesideLevel, setPricebesideLevel] = useState(null);
  const { id } = useParams();
  const queryClient = useQueryClient();

  useQuery(['patient', id], () =>
    api.getPatient(id).then((res) => {
      setFormData(res.data);
    }), {
    enabled: Boolean(id)
  }
  ) 

  const { isLoading, mutate } = useMutation(api.savePatient, {
    onSuccess: (data) => {
    
     if(data.status==200){
      props.openNoticeModal({
        isOpen: true,
        msg: data.message,
        msgtype: data.success,
      });

      let route = `edit/${data.list.PatientId}`;
      props.history.push(route);  

     }else{
      props.openNoticeModal({
        isOpen: true,
        msg: data.message,
        msgtype: data.success,
      });

     }
     
  
     
      // queryClient.getQueriesData('patients');
      // props.history.push('/patients');
    }
  })

  const handleChange = (e) => {
    const { name, value } = e.target;

    let data = { ...formData };
    data[name] = value;

    if (name === "OriginTypeId") {
      // Convert the value to a number before setting it in the state
      data[name] = parseInt(value, 10);
      
      data["TransferFromFacilityId"] = "";
      data["TransferToFacilityId"] = "";
      data["TransferFromCountryId"] = "";
      data["TransferToCountryId"] = "";
    }
    
    if (name == "idNumber") {
        const uppercaseValue = e.target.value.toUpperCase();
        data["idNumber"] = uppercaseValue;

    } 

    setFormData(data);

    //setFormData({ ...formData, [name]: value });
    setErrorObject({ ...errorObject, [name]: null });
  };


  //====== Start Choosen Dropdown===========
  const handleChangeChoosenProps = (name, value) => {
    let data = { ...formData };
    data[name] = value;   
    setFormData(data); 
    setErrorObject({ ...errorObject, [name]: "" });
  }
  //====== End Choosen Dropdown===========
  

  const handleCheck = (e) => {
    const { name, checked } = e.target;

    let data = { ...formData };
    data[name] = checked; 

   if(name === 'PreEP'){
      if(checked === true){
        data['active'] = false; 
      }
    }  

    if(name === 'active'){
      if(checked === true){
        data['temporaryPatient'] = false; 
      }
    }

    if(name === 'temporaryPatient'){
      if(checked === true){
        data['active'] = false; 
      }
    }

    setFormData(data);

    //setFormData({ ...formData, [name]: checked });
  };


  
const handleCheckPreEP = (e) => {
  const { name, checked } = e.target;

  let bDispenseVal = checked;

  let data = { ...formData };
  data[name] = checked; 


  if (bDispenseVal == true){
        swal({
          title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
          text:
          t(
            DispensingLanguage[lan][menukey][
              "Do you want to patient PreEP!"
            ]
          ),
          icon: "warning",
          buttons: [t(DispensingLanguage[lan][menukey]["No"]), 
          t(DispensingLanguage[lan][menukey]["Yes"])],
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {

            if(name === 'PreEP'){
  
              if(checked === true){
                
                data['active'] = false; 
              }
            }  
            setFormData(data);
            //setFormData({ ...formData, [name]: checked });

          } else {
            //refetch();
          }
        });
  }else{
    setFormData({ ...formData, [name]: checked });
  };
      

};
  
const handleCheckisArmy = (e) => {
  const { name, checked } = e.target;
  setFormData({ ...formData, [name]: checked });

};


  function tabChangeHandler(event, newValue) {
    setTabValue(newValue);
  }

  const handleChangeIndex = (index) => {
    setTabValue(index);
  };

  const handleRDateChange = (date, field) => {
    let data = { ...formData };
    data[field] = date;
    
    if((field === 'deceased') || (field === 'stopped') || (field === 'transferredOut') || (field === 'defaulter')){
      if(date !==''){
        data['active'] = false; 
      }
    }

    
    if(field === 'transfferedIn'){
      if(date !==''){
        data['TransferFromFacilityId'] = "";
        data["TransferFromCountryId"] = "";
      }
    }
    if(field === 'transferredOut'){
      if(date !==''){
        data['TransferToFacilityId'] = "";
        data["TransferToCountryId"] = "";
      }
    }
    

     let newDate;
    if(date==null){
     newDate=date;
    }else{
      newDate = format(new Date(date), 'yyyy-MM-dd');
    } 

   data[field] = newDate;

   setFormData(data);
  
    // setFormData({ ...formData, [field]: date });
    setErrorObject({ ...errorObject, [field]: null });
  };

  const handleReset = () => {
    setFormData({
      lastName: "",
      idNumber: "",
      registered: null,
      firstName: "",
      pass: generatedInvoiceNo,
      deceased: null,
      knownName: "",
      ipn: "",
      transfferedIn: null,
      gender: "",
      OriginTypeId: 1,
      dob: null,
      transferredOut: null,
      maritalStatus: "",
      active: "",
      PreEP: "",
      isArmy: "",
      InhIsPrevious: "",
      defaulter: null,
      languagePreference: "",
      ProtocolId: "",
      MmdId: "",
      ExistingProtocolId: "",
      ExistingMmdId: "",
      temporaryPatient: "",
      stopped: null,
      InhStartDate: null,
      InhEndDate: null,
      address: "",
      contactNumber: "",
      email: "",
      allergiesData: [],
      anthropometricsData: [],
      labResultsData: [],
      firstProtocolName: "",
      TransferFromFacilityId: "",
      TransferToFacilityId: "",
      TransferFromCountryId: "",
      TransferToCountryId: "",
      PatientcoinfectionId: "",
      KeypopulationTypeId: "",
      CohortId: ""
    });

    setAllergyData({
      id: null,
      date: null,
      allergyTitle: null,
      description: null,
      source: null
    })
  };

  const validateForm = (formData) => {
    // Mandatory Fields: Last name, First name, ID Number, DoB, Registered, Gender
    // let validateFields = ["lastName", "firstName", "idNumber", "dob", "registered", "gender"]
    let validateFields = ["idNumber", "dob", "registered", "gender"]
    let errorData = {}
    let isValid = true
    validateFields.map((field) => {
      
      
      /* if (formData['transfferedIn'] != null){
        if (formData['TransferFromFacilityId'] == ''){
          errorData['TransferFromFacilityId'] = DispensingLanguage[lan][menukey]['field is Required !'];
          isValid = false;
        }
      }

      if (formData['transferredOut'] != null){
        if (formData['TransferToFacilityId'] == ''){
          errorData['TransferToFacilityId'] = DispensingLanguage[lan][menukey]['field is Required !'];
          isValid = false;
        }
      } */

      if (formData["OriginTypeId"] === 1) {
        if (formData["transfferedIn"] != null) {
          if (formData["TransferFromFacilityId"] == "") {
            errorData["TransferFromFacilityId"] =
              DispensingLanguage[lan][menukey]["field is Required !"];
            isValid = false;
          }
        }

        if (formData["transferredOut"] != null) {
          if (formData["TransferToFacilityId"] == "") {
            errorData["TransferToFacilityId"] =
              DispensingLanguage[lan][menukey]["field is Required !"];
            isValid = false;
          }
        }
    }else{
      if (formData["transfferedIn"] != null) {
        if (formData["TransferFromCountryId"] == "") {
          errorData["TransferFromCountryId"] =
            DispensingLanguage[lan][menukey]["field is Required !"];
          isValid = false;
        }
      }

      if (formData["transferredOut"] != null) {
        if (formData["TransferToCountryId"] == "") {
          errorData["TransferToCountryId"] =
            DispensingLanguage[lan][menukey]["field is Required !"];
          isValid = false;
        }
      }
    }

      if (!formData[field]) {
        errorData[field] = DispensingLanguage[lan][menukey]['field is Required !'];
        isValid = false
      }
    })
    setErrorObject(errorData);
    return isValid
  }

  const validateAllergiesForm = (allergyData) => {
    let validateFields = ["date", "allergyTitle"]
    let errorAllergiesData = {}
    let isValid = true
    validateFields.map((field) => {
      if (!allergyData[field]) {
        errorAllergiesData[field] = DispensingLanguage[lan][menukey]['field is Required !'];
        isValid = false
      }
    })
    setErrorAllergiesObject(errorAllergiesData);
    return isValid
  }

  const validateAnthropometricsForm = (anthropometricData) => {
    let validateFields = ["date", "weight", "height"]
    let errorAnthropometricsData = {}
    let isValid = true
    validateFields.map((field) => {
      if (!anthropometricData[field]) {
        errorAnthropometricsData[field] = DispensingLanguage[lan][menukey]['field is Required !'];
        isValid = false
      }
    })
    setErrorAnthropometricsObject(errorAnthropometricsData);
    return isValid
  }

  const validateLabResultsForm = (labResultData) => {
    let validateFields = ["testDate", "testCode"]
    let errorLabResultsData = {}
    let isValid = true
    validateFields.map((field) => {
      if (!labResultData[field]) {
        errorLabResultsData[field] = DispensingLanguage[lan][menukey]['field is Required !'];
        isValid = false
      }
    })
    setErrorLabResultsObject(errorLabResultsData);
    return isValid
  }

  // const handleSubmit = async (e) => {
  //   if (validateForm(formData)) {
  //     mutate(formData);
       
  //   }
  // };

  const handleSubmit = async (e) => {
    if (validateForm(formData)) {
      let fDtat={...formData,"menukey": menukey,"lan":lan,"UserName":UserName}; 
      mutate(fDtat);
     // mutate(formData);
    }
  };

  //Tabs
  function ActionBtnAllergy (props) {
    const rowData = props.cell._cell.row.data;
    const cellValue = props.cell._cell.value || 'Edit | Show';
    return (
      <>
        <Edit onClick = {()=>{
          editTabRecord(rowData, props.tabName);
        }} />
        <DeleteOutline onClick = {()=>{
          deleteTabRecord(rowData, props.tabName);
        }} />
      </>
    )
  }

  function DateFormater(props: any) {
    const rowData = props.cell._cell.row.data;
    let date = new Date();
    switch (props.tabName) {
      case "labResultsData":
        date = rowData.testDate
        break;
      case "anthropometricsData":
        date = rowData.date
        break;
      case "allergiesData":
        date = rowData.date
        break;
    
      default:
        date = rowData.date
        break;
    }
    return (
      <>
        {format(new Date(date), 'd/MM/yyyy')}
      </>
    )
  }

  function PostedCheckBox(props: any) {
    const rowData = props.cell._cell.row.data;
    return (
      <>
       <input type = "checkbox" checked={rowData.status == "Posted"}/>
      </>
    )
  }

  const editTabRecord = (data, tabName) => {
    switch (tabName) {
      case "allergiesData":
        setAllergyDialog(true);
        setAllergyData(data);
        setErrorAllergiesObject({});
        break;
      case "anthropometricsData":
        setAnthropometricDialog(true);
        setAnthropometricData(data);
        setErrorAnthropometricsObject({});
        break;
      case "labResultsData":
        setLabResultDialog(true);
        setLabResultData(data);
        setErrorLabResultsObject({});
        break;

      default:
        break;
    }
  };

  const deleteTabRecord = (data, tabName) => {
    swal({
      title: t(DispensingLanguage[lan][menukey]['Are you sure?']),
      text: t(DispensingLanguage[lan][menukey]['Once deleted, you will not be able to recover this Record!']),
      icon: "warning",
      buttons: [t(DispensingLanguage[lan][menukey]["No"]), 
      t(DispensingLanguage[lan][menukey]["Yes"])],
      dangerMode: true,
    }).then((willDelete) => {

      if (willDelete) {

      switch (tabName) {
        case "allergiesData":
          setFormData({
            ...formData,
            allergiesData: [
              ...formData[tabName].filter((record) => record.id != data.id)
            ]
          });
          break;
        case "anthropometricsData":
          setFormData({
            ...formData,
            anthropometricsData: [
              ...formData[tabName].filter((record) => record.id != data.id)
            ]
          });
          break;
        case "labResultsData":
          setFormData({
            ...formData,
            labResultsData: [
              ...formData[tabName].filter((record) => record.id != data.id)
            ]
          });
          break;

        default:
          break;
      }

        swal(t(DispensingLanguage[lan][menukey]['Poof! Record has been deleted!']), {
          icon: "success",
        });
      }
    });
  };


  const calculateWeightCD4Count = () => {
    //option linechart Weight CD4 Count
    let data = { ...formData }
    let anthropometricsDataArray = data.anthropometricsData || []
    let allergiesDataArray = data.allergiesData || []
    let labResultsDataArray = data.labResultsData || []
    let dateList = []
    let list = []
    let weightList = []
    let cd4CountList = []
    if (anthropometricsDataArray.length > 0 && labResultsDataArray.length > 0) {
      dateList = anthropometricsDataArray.map((a) => format(new Date(a.date), 'MM/dd/yyyy'))
      labResultsDataArray.map((a) =>{
       // if(a.testCode == "CD4"){
        if(a.IsCD4 === 1){
          dateList.push(format(new Date(a.testDate), 'MM/dd/yyyy'));
        }
      })
      list = dateList.filter((c, index) => {
        return dateList.indexOf(c) === index;
      });
      list = list.sort((a, b) => new Date(a) - new Date(b));
      list = list.map((date) => format(new Date(date), 'dd/MM/yyyy'))

      list.map((xAxisDate) => {
        let weightvalue = 0
        anthropometricsDataArray.map((anth) => {
          let anthropometricDate = format(new Date(anth.date), 'dd/MM/yyyy')
          if (xAxisDate == anthropometricDate) {
            weightvalue = parseFloat(anth.weight)
          }
        })
        weightList.push(weightvalue);
        let cd4Value = 0
        labResultsDataArray.map((lab) => {
          let labResultDate = format(new Date(lab.testDate), 'dd/MM/yyyy')
          //if (lab.testCode == "CD4" && xAxisDate == labResultDate) {
          if (lab.IsCD4 === 1 && xAxisDate == labResultDate) {
            cd4Value = parseFloat(lab.testResult);
          }
        })
        cd4CountList.push(cd4Value);
      })
    }


    let option_linechart_WeightCD4Count = {
      chart: {
        type: "line",
      },
      title: {
        text: "",
      },
      yAxis: {
        title: {
          text: "",
        },
      },
      xAxis: {
        categories: list,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: "Weight",
          data: weightList || [],
          color: "#6c6463",
        },
        {
          name: "CD4 Count",
          data: cd4CountList || [],
          color: "#b60024",
        },
      ],
    };

    return option_linechart_WeightCD4Count
  }

  const calculateViralLoad = () => {
    //option linechart Weight CD4 Count
    let data = { ...formData }
    let labResultsDataArray = data.labResultsData || []
    let dateList = []
    let list = []
    let cd4CountList = []
    if (labResultsDataArray.length > 0) {
      labResultsDataArray.map((a) => {
        //if(a.testCode == "VL"){
        if(a.IsVirale === 1){
          dateList.push(format(new Date(a.testDate), 'MM/dd/yyyy'));
        }
      })
      list = dateList.filter((c, index) => {
        return dateList.indexOf(c) === index;
      });
      list = list.sort((a, b) => new Date(a) - new Date(b));
      list = list.map((date) => format(new Date(date), 'dd/MM/yyyy'))

      list.map((xAxisDate) => {
        let cd4Value = 0
        labResultsDataArray.map((lab) => {
          let labResultDate = format(new Date(lab.testDate), 'dd/MM/yyyy')
          //if (lab.testCode == "VL" && xAxisDate == labResultDate) {
          if (lab.IsVirale === 1 && xAxisDate == labResultDate) {
            cd4Value = parseFloat(lab.testResult);
          }
        })
        cd4CountList.push(cd4Value);
      })
    }


    //option linechart Weight CD4 Count
    let option_linechart_ViralLoad = {
      chart: {
        type: "line",
      },
      title: {
        text: "",
      },
      yAxis: {
        title: {
          text: "",
        },
      },
      xAxis: {
        categories: list,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: "Viral Load",
          data: cd4CountList || [],
          color: "#b60024",
        },
      ],
    };

    return option_linechart_ViralLoad
  }

  const allergyDataColumns = [
    { title: t(DispensingLanguage[lan][menukey]['Date']), field: 'date', formatter: reactFormatter(<DateFormater tabName = "allergiesData"/>) },
    { title: t(DispensingLanguage[lan][menukey]['Allergy']) , field: 'allergyTitle' },
    { title: t(DispensingLanguage[lan][menukey]['Description']) , field: 'description' },
    { title: t(DispensingLanguage[lan][menukey]['Source']) , field: 'source' },
    { title: t(DispensingLanguage[lan][menukey]['Actions']) , field: 'custom', hozAlign: 'center',width: 150, formatter: reactFormatter(<ActionBtnAllergy tabName = "allergiesData" />) },
  ];

  const anthropometricDataColumns = [
    { title: t(DispensingLanguage[lan][menukey]['Date']) , field: 'date', formatter: reactFormatter(<DateFormater tabName = "anthropometricsData"/>) },
    { title: t(DispensingLanguage[lan][menukey]['Weight in KG']) , field: 'weight' },
    { title: t(DispensingLanguage[lan][menukey]['Height in CM']) , field: 'height' },
    { title: t(DispensingLanguage[lan][menukey]['BMI']) , field: 'bmi' },
    { title: t(DispensingLanguage[lan][menukey]['BSA']) , field: 'bsa' },
    { title: t(DispensingLanguage[lan][menukey]['Actions']) , field: 'custom', hozAlign: 'center',width: 150, formatter: reactFormatter(<ActionBtnAllergy tabName = "anthropometricsData" />) },
  ];

  const labResultsDataColumns = [
    { title: t(DispensingLanguage[lan][menukey]['Test Date']) , field: 'testDate', formatter: reactFormatter(<DateFormater tabName = "labResultsData"/>) },
    { title: t(DispensingLanguage[lan][menukey]['Test Code']) , field: 'testCode' },
    { title: t(DispensingLanguage[lan][menukey]['Test Name']) , field: 'testName' },
    { title: t(DispensingLanguage[lan][menukey]['Test Result']) , field: 'testResult' },
    { title: t(DispensingLanguage[lan][menukey]['Place']) , field: 'place' },
    { title: t(DispensingLanguage[lan][menukey]['Actions']), field: 'custom', hozAlign: 'center',width: 150, formatter: reactFormatter(<ActionBtnAllergy tabName = "labResultsData" />) },
  ];

  // const prescriptionDataColumns = [
  //   { title: 'Date', field: 'prescriptionDate', formatter: reactFormatter(<DateFormater tabName="prescriptionDate" />) },
  //   { title: "RxNumber", field: "prescriptionNumbar" },
  //   { title: 'Prescriber', field: 'prescriber' },
  //   {
  //     title: "Posted",
  //     field: "posted",
  //     align: "center",
  //     formatter: reactFormatter(<PostedCheckBox />)
  //   },
  //   {
  //     title: "Cost (CFA)",
  //     field: "cost",
  //     align: "right",
  //   },
  // ];

  const generateIds = () => {
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < 5; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  const handleClickOpen = (tabName) => {
    switch (tabName) {
      case "allergiesData":
        setAllergyDialog(true);
        break;
      case "anthropometricsData":
        setAnthropometricDialog(true)
        break;
      case "labResultsData":
        setLabResultDialog(true);
        break;
    }
    
  }

  const handleClose = () => {
    setAllergyDialog(false);
    setAnthropometricDialog(false);
    setLabResultDialog(false);

    setAllergyData({
      id: null,
      date: null,
      allergyTitle: null,
      description: null,
      source: null
    });
    setAnthropometricData({
      id: null,
      date: null,
      weight: null,
      height: null,
      bmi: null,
      bsa: null
    });
    setLabResultData({
      id: null,
      testCode: null,
      testName: null,
      testResult: null,
      testDate: null,
      place: null
    });
  }

  const handleChangeByTabs = (e, tabName) => {
    const { name, value } = e.target;
    if (tabName == "allergyData") {
      setAllergyData({
        ...allergyData, [name]: value
      });
      setErrorAllergiesObject({});
    }
    if (tabName == "anthropometricsData") {
      setAnthropometricData({
        ...anthropometricData, [name]: value
      });
      setErrorAnthropometricsObject({});
    }
    if (tabName == "labResultsData") {
      setLabResultData({
        ...labResultData, [name]: value
      });
      setErrorLabResultsObject({});
    }
  };

  const handleRDateChangeByTabs = (date, field, tabName) => {
    if (tabName == "allergyData") {
      setAllergyData({ ...allergyData, [field]: date });
      setErrorAllergiesObject({});
    }
    if (tabName == "anthropometricsData") {
      setAnthropometricData({ ...anthropometricData, [field]: date });
      setErrorAnthropometricsObject({});
    }
    if (tabName == "labResultsData") {
      setLabResultData({ ...labResultData, [field]: date });
      setErrorLabResultsObject({});
    }
  };

  const handleSubmitByTabs = (tabName) => {
    if (tabName == "allergyData") {
      let updateRecord = false
      if (allergyData.id && formData.allergiesData && formData.allergiesData.find((record) => record.id == allergyData.id)) {
        updateRecord = true
      }
      if (allergyData.date == null) {
        allergyData.date = new Date();
      }
      if (validateAllergiesForm(allergyData)) {
        if (updateRecord) {
          formData['allergiesData'] = formData['allergiesData'].map((record) => {
            if (record.id == allergyData.id) {
              record = allergyData
            }
            return record
          })
        } else {
          allergyData['id'] = generateIds();
          formData['allergiesData'] = formData['allergiesData'].concat(allergyData);
        }

        setAllergyData({
          id: null,
          date: null,
          allergyTitle: null,
          description: null,
          source: null
        });
        setAllergyDialog(false);

        if (validateForm(formData)) {
          mutate(formData);
          
        }
      }
    }

    if (tabName == "anthropometricsData") {
      let updateRecord = false
      if (anthropometricData.id && formData.anthropometricsData && formData.anthropometricsData.find((record) => record.id == anthropometricData.id)) {
        updateRecord = true
      }
      if (anthropometricData.date == null) {
        anthropometricData.date = new Date();
      }
      if (anthropometricData.height && anthropometricData.weight) {
        //BMI
        let weight = parseFloat(anthropometricData.weight)
        let height = parseFloat(anthropometricData.height)
        anthropometricData.bmi = Number((weight / Math.pow(height, 2)).toFixed(2));

        //BSA
        anthropometricData.bsa = Number(0.007184 * Math.pow(height, 0.725) * Math.pow(weight, 0.425)).toFixed(2);
      }
      if (validateAnthropometricsForm(anthropometricData)) {
        anthropometricData.weight = parseFloat(anthropometricData.weight).toFixed(2)
        anthropometricData.height = parseFloat(anthropometricData.height).toFixed(2)
        if (updateRecord) {
          formData['anthropometricsData'] = formData['anthropometricsData'].map((record) => {
            if (record.id == anthropometricData.id) {
              record = anthropometricData
            }
            return record
          })
        } else {
          anthropometricData['id'] = generateIds();
          formData['anthropometricsData'] = formData['anthropometricsData'].concat(anthropometricData);
        }

        setAnthropometricData({
          id: null,
          date: null,
          weight: null,
          height: null,
          bmi: null,
          bsa: null
        });
        setAnthropometricDialog(false);
        if (validateForm(formData)) {
          mutate(formData); 
        }
      }
    }

    if (tabName == "labResultsData") {
      let updateRecord = false
      if (labResultData.testCode) {
        let labTestNames = LABTest_List
        let selectedTest = labTestNames.find((test) => test.id == labResultData.testCode)
        if (selectedTest) {
          labResultData['testName'] = selectedTest.name
          labResultData['testCode'] = selectedTest.id
        }
      }
      if (labResultData.testDate == null) {
        labResultData.testDate = new Date();
      }
      if (labResultData.id && formData.labResultsData && formData.labResultsData.find((record) => record.id == labResultData.id)) {
        updateRecord = true
      }
      if (validateLabResultsForm(labResultData)) {
        if (updateRecord) {
          formData['labResultsData'] = formData['labResultsData'].map((record) => {
            if (record.id == labResultData.id) {
              record = labResultData
            }
            return record
          })
        } else {
          labResultData['id'] = generateIds();
          formData['labResultsData'] = formData['labResultsData'].concat(labResultData);
        }

        setLabResultData({
          id: null,
          testCode: null,
          testName: null,
          testResult: null,
          testDate: null,
          place: null
        });
        setLabResultDialog(false);
        if (validateForm(formData)) {
          mutate(formData);
          
        }
      }
    }
  };

  return (
    <>
      <PatientFormData tabValue = {tabValue}
        errorObject = {errorObject}
        handleRDateChange = {handleRDateChange}
        handleChangeIndex = {handleChangeIndex}
        tabChangeHandler = {tabChangeHandler}
        addPatientForm = {true}
        formData = {formData}
        handleChange = {handleChange}
        handleChangeChoosenProps = {handleChangeChoosenProps}
        handleCheck = {handleCheck}
        handleCheckPreEP = {handleCheckPreEP}
        handleCheckisArmy = {handleCheckisArmy}
        handleReset = {handleReset}
        handleSubmit = {handleSubmit}
        handleChangeByTabs = {handleChangeByTabs}
        allergyData = {allergyData}
        handleSubmitByTabs = {handleSubmitByTabs}
        handleClickOpen = {handleClickOpen}
        handleClose = {handleClose}
        openAllergyDialog = {openAllergyDialog}
        openAnthropometricDialog = {openAnthropometricDialog}
        handleRDateChangeByTabs = {handleRDateChangeByTabs}
        allergyDataColumns = {allergyDataColumns}
        anthropometricDataColumns = {anthropometricDataColumns}
        anthropometricData = {anthropometricData}
        labResultsDataColumns = {labResultsDataColumns}
        setLabResultDialog = {setLabResultDialog}
        labResultData = {labResultData}
        openLabResultDialog = {openLabResultDialog}
        errorAllergiesData = {errorAllergiesData}
        errorAnthropometricsData = {errorAnthropometricsData}
        errorLabResultsData = {errorLabResultsData}
        calculateWeightCD4Count={calculateWeightCD4Count}
        calculateViralLoad={calculateViralLoad}
        // patientsPrescriptions = {patientsPrescriptions}
        // prescriptionDataColumns = {prescriptionDataColumns}
        {...props} 
      />
    </>
  );
};

export default AddPatient;